/**
 * Soft frosted blobs behind the header pill — similar to theme "overlay-shape" + mega-menu glass.
 */
export default function HeaderGlassOverlay({ sticky = false }) {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-0 overflow-hidden rounded-[inherit]"
      aria-hidden
    >
      {sticky ? (
        <>
          <div className="absolute -left-[18%] top-1/2 h-[170%] w-[52%] -translate-y-1/2 rounded-full bg-white/75 blur-[46px]" />
          <div className="absolute -right-[12%] -top-[38%] h-[125%] w-[44%] rounded-full bg-neutral-200/55 blur-[54px]" />
          <div className="absolute bottom-[-20%] left-[18%] h-[65%] w-[58%] rounded-full bg-white/45 blur-[38px]" />
          <div className="absolute inset-0 bg-gradient-to-br from-white/35 via-white/15 to-neutral-100/25" />
        </>
      ) : (
        <>
          <div className="absolute -left-[24%] top-1/2 h-[195%] w-[58%] -translate-y-1/2 rounded-full bg-white/45 blur-[56px]" />
          <div className="absolute -right-[20%] -top-[48%] h-[145%] w-[50%] rounded-full bg-emerald-100/35 blur-[64px]" />
          <div className="absolute bottom-[-28%] left-[15%] h-[78%] w-[68%] rounded-full bg-white/30 blur-[48px]" />
          <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/25 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-forest/15 via-transparent to-white/10" />
        </>
      )}
    </div>
  );
}
